import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import { PhUsersThree } from 'ember-phosphor-icons';
import HeroStat from 'tio-employee/components/dashboard-kit/hero-stat';
import type { QueueSnapshot } from 'tio-employee/utils/partner-dashboard/sources/approval-queue';
import type { WidgetComponentSignature } from 'tio-employee/utils/partner-dashboard/registry';

/** Hero tile: items the viewer could review that are waiting on another approver first. */
const WaitingOnOthersWidget: TOC<WidgetComponentSignature<QueueSnapshot>> = <template>
  <HeroStat
    @emphasis="metric"
    @label={{t "partner_dashboard.queue.waiting_on_others"}}
    @value={{@data.waitingOnOthers}}
    @context={{t "partner_dashboard.queue.waiting_on_others_context"}}
    @contextIcon={{PhUsersThree}}
    data-test-partner-dashboard-waiting-on-others
  />
</template>;

export default WaitingOnOthersWidget;
